import React from "react";
import {BaseThatsMeIconProps} from "../../interfaces/baseThatsMeIconProps.interface";
import {useTheme} from "@mui/material";

export default (props: BaseThatsMeIconProps) => {
    const theme = useTheme();
    const {size = 24, fill= theme.palette.thatsMe.iconsDefault, ...rest} = props;
    return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M17.1378 18.4641C18.465 18.6469 19.7604 18.8972 21.024 19.2151V20.9913C18.2107 20.284 15.2463 19.9304 12.131 19.9304C9.01568 19.9304 6.05136 20.284 3.23804 20.9913V19.2151C4.50165 18.8972 5.79705 18.6469 7.12425 18.4641V5.05311C5.79705 4.87033 4.50165 4.62 3.23804 4.30209V2.52588C6.05136 3.2332 9.01568 3.58685 12.131 3.58684C15.2463 3.58685 18.2107 3.2332 21.024 2.52588V4.30209C19.7604 4.62 18.465 4.87033 17.1378 5.05311V18.4641ZM15.3497 5.24384C14.2927 5.33127 13.2198 5.37498 12.131 5.37497C11.0422 5.37498 9.96935 5.33127 8.91238 5.24384V18.2734C9.96935 18.1859 11.0422 18.1422 12.131 18.1422C13.2198 18.1422 14.2927 18.1859 15.3497 18.2734V5.24384Z"
            fill={fill}/>
    </svg>
}
